import {
	types, Instance,
} from 'mobx-state-tree';

import Service from '@common/models/Services/Service';
import ServiceTemplateCharacteristic from './ServiceTemplateCharacteristic';

const ServiceTemplate = types
	.model('ServiceTemplate', {
		id: types.identifierNumber,
		name: types.string,
		service: types.reference(Service),
		service_template_characteristics: types.optional(
			types.array(ServiceTemplateCharacteristic),
			[],
		),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({

	}))
	.actions(() => ({

	}));

export default ServiceTemplate;

export interface IServiceTemplateModel extends Instance<typeof ServiceTemplate> {}
